import { React, useState, useEffect, useLayoutEffect, useRef } from 'react'
import { createPortal } from 'react-dom';
import "../css/ComponentStyle.css";
import "../css/PagesCommonStyle.css";
import { json, useLocation, useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { Button } from 'bootstrap';
import { faCircleXmark, faCircleCheck, faPrint, faFlag, faGear, faFileInvoiceDollar, faClock, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRightFromBracket, faBars } from '@fortawesome/free-solid-svg-icons'
import { CommonAPIConstants, APIConstants, LoginConstants } from '../utilities/Constants';
import { set } from 'date-fns';
import { useDispatch } from 'react-redux';
import { ClearDemoGraphyData } from '../redux/actions/userActions';
import { setAuthToken } from '../redux/actions/userActions';
// Billing-domain icons: a gauge for the dashboard, an invoice for claims, a
// patient for the tracker, a bar chart for reports. The old markup composed
// two of these by hand out of fa-stack/fa-layers - a rectangle with a user
// punched through it, a square with a document on top - which collapsed into
// an unreadable blob at nav-bar size.
import { faGaugeHigh, faHospitalUser, faChartColumn, faStopwatch } from '@fortawesome/free-solid-svg-icons'
import "bootstrap-icons/font/bootstrap-icons.css";



const DropdownMenu = ({
  icon,
  customIcon,
  options,
  activePage,
  handleMenuClick,
  openDropdown,
  handleDropdownToggle,
  menuName,
  title
}) => {
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);
  const [menuPosition, setMenuPosition] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // The menu is portalled to <body>, so it is no longer a DOM descendant of the
      // trigger. Both have to be checked or clicking the menu closes it immediately.
      const bInsideMenu = dropdownRef.current && dropdownRef.current.contains(event.target);
      const bInsideTrigger = triggerRef.current && triggerRef.current.contains(event.target);

      if (!bInsideMenu && !bInsideTrigger) {
        if (openDropdown === menuName) {
          handleDropdownToggle(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openDropdown, menuName, handleDropdownToggle]);

  const isActive = options.some((option) => option.value === activePage);
  const isOpen = openDropdown === menuName;

  /**
   * Anchors the portalled menu underneath its icon.
   *
   * .nav-container sets overflow-x:auto so the bar scrolls instead of crushing its
   * contents on a narrow viewport. CSS will not let one axis scroll while the other stays
   * visible - overflow-y computes to auto alongside it - so the bar clipped every menu at
   * its own 40px height and the options became unreachable. Rendering the menu into <body>
   * takes it out of that clipping box entirely, which keeps both behaviours.
   *
   * Measured in a layout effect so the position is written before the browser paints,
   * otherwise the menu appears at the top-left corner for one frame and jumps.
   */
  useLayoutEffect(() => {
    if (!isOpen) {
      setMenuPosition(null);
      return undefined;
    }

    const place = () => {
      const trigger = triggerRef.current;
      if (!trigger) return;

      const rect = trigger.getBoundingClientRect();
      setMenuPosition({ top: rect.bottom, left: rect.left + rect.width / 2 });
    };

    place();

    // The bar scrolls horizontally and the page scrolls vertically; a fixed menu does not
    // follow either on its own, so it would drift away from its icon.
    window.addEventListener("scroll", place, true);
    window.addEventListener("resize", place);

    return () => {
      window.removeEventListener("scroll", place, true);
      window.removeEventListener("resize", place);
    };
  }, [isOpen]);

  return (
    <li
      ref={triggerRef}
      title={title}
      style={{ position: "relative", listStyle: "none", cursor: "pointer" }}
      onMouseEnter={() => handleDropdownToggle(menuName)}
      onMouseLeave={() => handleDropdownToggle(null)}
    >
      <div
        className={`dropdown-trigger ${isActive ? "active-icon" : ""}`}
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        {customIcon ? (typeof customIcon === "function" ? customIcon() : customIcon) : <FontAwesomeIcon icon={icon} />}
      </div>

      {isOpen && menuPosition && createPortal(
        <ul
          ref={dropdownRef}
          // The pointer leaves the <li> on its way to the menu, and onMouseLeave there
          // would close it mid-reach. Re-asserting it here keeps it open while hovered.
          onMouseEnter={() => handleDropdownToggle(menuName)}
          onMouseLeave={() => handleDropdownToggle(null)}
          style={{
            position: "fixed",
            top: menuPosition.top,
            left: menuPosition.left,
            transform: "translateX(-50%)",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
            borderRadius: "8px",
            padding: "10px 0",
            minWidth: "180px",
            listStyle: "none",
            zIndex: 9999,
            textAlign: "left",
            margin: 0
          }}
        >
          {options.map((option, index) => (
            <li
              key={index}
              className={`dropdown-item ${activePage === option.value ? "active-record" : ""}`}
              onClick={() => {
                handleMenuClick(option.value);
                handleDropdownToggle(null);
              }}
              style={{
                padding: "10px 16px",
                cursor: "pointer",
                fontSize: "0.9rem",
                fontWeight: "500",
                transition: "background-color 0.2s ease-in-out",
                whiteSpace: "nowrap"
              }}
            >
              <a
                style={{
                  color: "#333",
                  textDecoration: "none",
                  display: "block",
                  width: "100%",
                  height: "100%"
                }}
                onMouseEnter={(e) => (e.target.parentElement.style.backgroundColor = "skyblue")}
                onMouseLeave={(e) => (e.target.parentElement.style.backgroundColor = "transparent")}
              >
                {option.label}
              </a>
            </li>
          ))}
        </ul>,
        document.body
      )}
    </li>
  );
};






// isSidebarOpen / toggleSidebar are owned by App so the sidebar can sit beside
// the routed page inside .hv-shell. The hamburger below is unchanged — it just
// calls the toggle it is handed instead of a local one.
const Navbar = ({ handleLogout, toggleSidebar, isSidebarOpen }) => {


  const { id } = useParams();

  const dropdownRef = useRef(null);
  const userData = useSelector((state) => state.user.user);

  var userPracticeID = userData ? userData.practiceID : null;

  // The header now shows the role above the name (BILLER / Test Biller). The login
  // payload does not guarantee a role field, so fall back to the role this app logs in
  // as (RoleID 7 - biller) rather than rendering an empty line above the name.
  const roleLabel = userData?.roleName || userData?.userRole || userData?.userType || "Biller";

  var userId = userData ? userData.userID : null;



  const navigate = useNavigate();

  const [newToken, setNewToken] = useState(null);


  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showClockModal, setShowClockModal] = useState(false);

  const [checkinStatus, setCheckinStatus] = useState(0);
  const [totalCheckinCount, setTotalCheckinCount] = useState(0);
  const [lastCheckout, setLastCheckout] = useState('');
  const [totalDuration, setTotalDuration] = useState('');
  const [duration, setDuration] = useState('00:00');
  const [firstCheckinTime, setFirstCheckinTime] = useState('');
  const [CheckOutTime, setCheckOutTime] = useState('');
  const [checkInStatusData, setCheckInStatusData] = useState('');
  const [checkOutStatus, setCheckOutStatus] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const [intervalId, setIntervalId] = useState(null);
  const [timerInterval, setTimerInterval] = useState(null);
  const autoCloseTimerRef = useRef(null);

  const [selectedSearchFilter, setSelectedSearchFilter] = useState('0');
  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [lastSelectedItem, setLastSelectedItem] = useState(null);
  const [activePage, setActivePage] = useState(() => {
    return window.location.hash.replace("#/", "") || "";
  });

  const location = useLocation();
  const dispatch = useDispatch();

  const DemoGraphyData = useSelector((state) => state.user.demoDetails);


  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${month}/${day}/${year}`;
  };


  const defaultDate = getCurrentDate();











  const formatTime = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    return `${hours}:${minutes}:${seconds} ${ampm}`;
  };





  const [currentTime, setCurrentTime] = useState(formatTime(new Date()));





  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(formatTime(new Date()));
    }, 1000);


    return () => clearInterval(interval);
  }, []);


  // Clear the clock-out auto-close timer if the navbar unmounts.
  useEffect(() => {
    return () => {
      if (autoCloseTimerRef.current) clearTimeout(autoCloseTimerRef.current);
    };
  }, []);





  // The click-outside-to-close effect that used to live here is gone: the
  // sidebar is no longer a child of Navbar, so sidebarRef could never contain
  // it. Dismissal is now the scrim (overlay mode) and Escape, both in App.
  // On desktop the sidebar pushes the page, so an outside click must NOT close
  // it — otherwise the page becomes unusable while the menu is open.





  const incrementDuration = () => {
    const [minutes, seconds] = totalDuration.split(':').map(Number);
    const newSeconds = (seconds + 1) % 60;
    const newMinutes = minutes + (seconds + 1 >= 60 ? 1 : 0);
    setTotalDuration(
      `${String(newMinutes).padStart(2, '0')}:${String(newSeconds).padStart(2, '0')}`
    );
  };


  useEffect(() => {
    if (checkinStatus) {
      const interval = setInterval(incrementDuration, 60000);
      return () => clearInterval(interval);
    }
  }, [checkinStatus, totalDuration]);







  //   const INACTIVITY_TIMEOUT = 20 * 60 * 1000;


  // useEffect(() => {
  //   let interval;

  //   const resetTimer = () => {
  //     localStorage.setItem('lastActivity', Date.now().toString());
  //   };

  //   const checkInactivity = () => {
  //     const lastActivity = parseInt(localStorage.getItem('lastActivity') || '0', 10);
  //     if (Date.now() - lastActivity > INACTIVITY_TIMEOUT) {
  //       cleanup();
  //       handleLogout();
  //     }
  //   };

  //   const cleanup = () => {
  //     events.forEach((event) => window.removeEventListener(event, resetTimer));
  //     clearInterval(interval);
  //   };

  //   // Events that reset the inactivity timer
  //   const events = ['mousemove', 'keypress', 'click'];
  //   events.forEach((event) => window.addEventListener(event, resetTimer));

  //   // Start the interval
  //   interval = setInterval(checkInactivity, 1000);

  //   // Initialize timer
  //   resetTimer();

  //   return () => {
  //     cleanup();
  //   };
  // }, []);





  //     useEffect(() => {
  // if(userData) {
  //         fetchNewToken();

  //         const interval = setInterval(() => {
  //             fetchNewToken();
  //         }, 20* 60 * 1000); // 20 minutes

  //         return () => clearInterval(interval);
  //       }
  //     }, [dispatch]);



  // useEffect(() => {
  //     if (newToken) {
  //         console.log("✅ AFTER 20 min Updated AuthToken:", newToken);
  //         dispatch(setAuthToken(newToken));
  //     }
  // }, [newToken, dispatch]);





  // const fetchNewToken = () => {


  //     var inputJSON = {

  //         UserName: userData.Username,
  //         PracticeId: userPracticeID,

  //     }

  //     var sJSONInput = JSON.stringify(inputJSON);
  //     console.log("input of" + LoginConstants.UpdatedToken, inputJSON);

  //     const url = `${APIConstants.SERVICES_URL}${LoginConstants.UpdatedToken}?sInputJSON=${sJSONInput}`;

  //     console.log("URL: ", url);

  //     fetch(url, {
  //         method: 'GET',
  //         headers: {
  //             'Accept': 'application/json',
  //             'Content-Type': 'application/json'
  //         }
  //     })

  //         .then((response) => {
  //             if (response.status != 200) { console.log("response.status", response.status); }
  //             else return response.json();
  //         })
  //         .then(data => {



  //             const parsedData = JSON.parse(data);

  //             setNewToken(parsedData.AuthToken)

  //             dispatch(setAuthToken(parsedData.AuthToken));
  //             console.log("✅Updated Token???????????????", parsedData);


  //         })
  //         .catch((error) => {
  //             console.error('Error fetching :', error);
  //         });
  // };






  const handleCloseModals = () => {
    // Close all modals

    if (autoCloseTimerRef.current) {
      clearTimeout(autoCloseTimerRef.current);
      autoCloseTimerRef.current = null;
    }

    setShowClockModal(false);
    setCheckOutStatus(false)

  };


  const handleOpenModal = () => {



    setShowClockModal(true);

  };




  const fetchUserClockStatus = (showModal = true, promptIfNotCheckedIn = false) => {

    if (showModal) setShowClockModal(true)
    setCheckOutStatus(false)

    const objInput = {
      objTimeSheet: {
        isFromApp: 0,
        UserID: userData.userID,
        PracticeID: userPracticeID,
        DefaultTimeZoneOffSet: 300
      }
    };

    var myInput = JSON.stringify(objInput);

    const url = `${APIConstants.BASE_URL_TIMESHEET}${CommonAPIConstants.GetUserClockStatus}?sInputJSON=${myInput}`;
    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(resData => {

        const parsedData = JSON.parse(resData)

        console.log("tableData of  " + CommonAPIConstants.GetUserClockStatus, parsedData);


        setTotalCheckinCount(parsedData.TotalCheckinCount);
        //setTotalDuration(parsedData.TotalDuration);
        setDuration(parsedData.TotalDuration);
        setFirstCheckinTime(parsedData.FirstCheckinTime);
        setLastCheckout(parsedData.TotalCheckinCount == 0 ? '' : parsedData.LastCheckout);
        setCheckinStatus(parsedData.CheckinStatus);
        setCheckInStatusData(parsedData)


        // Once-per-day auto prompt: open the clock-in popup the first time the
        // portal is opened each day if the user is not clocked in. The stored
        // date guard stops it reappearing on refreshes for the rest of the day.
        if (promptIfNotCheckedIn && parsedData.CheckinStatus == 0) {
          const today = getCurrentDate();
          if (localStorage.getItem('clockInPromptDate') !== today) {
            localStorage.setItem('clockInPromptDate', today);
            setShowClockModal(true);
          }
        }


        localStorage.setItem("totalCheckinCount", JSON.stringify(parsedData.TotalCheckinCount));
        localStorage.setItem("duration", JSON.stringify(parsedData.TotalDuration));
        localStorage.setItem("firstCheckinTime", JSON.stringify(parsedData.FirstCheckinTime));
        localStorage.setItem("lastCheckout", parsedData.TotalCheckinCount == 0 ? '' : parsedData.LastCheckout);
        localStorage.setItem("checkinStatus", JSON.stringify(parsedData.CheckinStatus));
        localStorage.setItem("checkInStatusData", JSON.stringify(parsedData));



        setLoading(false);
      })
      .catch((error) => {
        console.error('API request failed', error);
        setLoading(false);
      });
  };




  useEffect(() => {
    if (location.pathname === '/Billingdasboard') {
      fetchUserClockStatus(false, true);
      dispatch(ClearDemoGraphyData());


    }
  }, [initialized, location.pathname]);


  // On login (whenever a user becomes available), fetch the real clock status
  // from the server — without opening the modal — so the navbar shows the
  // correct button: "Clock-in" if not clocked in, or the "clock-out" pill if
  // the user already clocked in earlier. This avoids relying on stale
  // localStorage after a logout/login cycle.
  useEffect(() => {
    if (userData && userData.userID && userPracticeID) {
      fetchUserClockStatus(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData && userData.userID]);








  useEffect(() => {
    const savedCheckinStatus = localStorage.getItem("checkinStatus");
    const savedTotalDuration = localStorage.getItem("totalDuration");
    const savedFirstCheckinTime = localStorage.getItem("firstCheckinTime");
    const savedCheckOutTime = localStorage.getItem("checkOutTime");
    const savedCheckOutStatus = localStorage.getItem("checkOutStatus");
    const savedLastCheckOut = localStorage.getItem("lastCheckout");

    if (savedCheckinStatus) setCheckinStatus(Number(savedCheckinStatus));
    if (savedTotalDuration) setTotalDuration(savedTotalDuration);
    if (savedFirstCheckinTime) setFirstCheckinTime(savedFirstCheckinTime);
    if (savedCheckOutTime) setCheckOutTime(savedCheckOutTime);
    // Do NOT restore checkOutStatus on load — the "Checked Out" card should
    // only appear right after the user clicks Clock Out, not on every refresh.
    setCheckOutStatus(false);
    if (savedLastCheckOut) setLastCheckout(Number(savedLastCheckOut));

  }, []);




  const updateLocalStorage = () => {
    localStorage.setItem("checkinStatus", checkinStatus);
    localStorage.setItem("totalDuration", totalDuration);
    localStorage.setItem("firstCheckinTime", firstCheckinTime);
    localStorage.setItem("checkOutTime", CheckOutTime);
    localStorage.setItem("checkOutStatus", JSON.stringify(checkOutStatus));
    localStorage.setItem("lastCheckout", lastCheckout);
  };

  useEffect(() => {
    updateLocalStorage();
  }, [checkinStatus, totalDuration, firstCheckinTime, CheckOutTime, checkOutStatus, lastCheckout]);









  const fetchUserClockIn = () => {



    var today = new Date();

    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();



    var UserDetails =
    {

      UserID: userData.userID,
      Lattitude: 0,
      Longitude: 0,
      CheckinoutTime: time,
      CheckinoutDate: date,
      isServerTime: 1,
      PracticeID: userPracticeID,
      DefaultTimeZoneOffSet: 300
    }


    var locString = JSON.stringify(JSON.stringify({ 'objTimeSheet': UserDetails }));


    const response = fetch(APIConstants.BASE_URL_TIMESHEET + CommonAPIConstants.GetUserClockIn, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: locString
    })

      .then((response) => response.json())
      .then((data) => {
        const parsedData = JSON.parse(data)

        // if (parsedData.CheckinStatus !== 0) {
        //   // Set a timeout to recheck status every 5 minutes if checked in
        //   setTimeout(fetchUserClockIn, 300000);
        // }


        setCheckinStatus(parsedData.CheckinStatus)
        setTotalDuration(parsedData.TotalDuration)
        setFirstCheckinTime(parsedData.FirstCheckinTime)

        setShowClockModal(false)

        localStorage.setItem("checkinStatus", parsedData.CheckinStatus);
        localStorage.setItem("totalDuration", parsedData.TotalDuration);
        localStorage.setItem("firstCheckinTime", parsedData.FirstCheckinTime);


      })
      .catch((error) => {
        console.error('Error fetching CPT names:', error);

      });
  };







  const fetchUserClockOut = () => {



    var today = new Date();

    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();



    var UserDetails =
    {

      UserID: userData.userID,
      Lattitude: 0,
      Longitude: 0,
      CheckinoutTime: time,
      CheckinoutDate: date,
      isServerTime: 1,
      PracticeID: userPracticeID,
      DefaultTimeZoneOffSet: 300
    }


    var locString = JSON.stringify(JSON.stringify({ 'objTimeSheet': UserDetails }));



    const response = fetch(APIConstants.BASE_URL_TIMESHEET + CommonAPIConstants.GetUserClockOut, {
      method: 'POST',

      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: locString
    })

      .then((response) => response.json())
      .then((data) => {

        const parsedData = JSON.parse(data)


        //  setDuration(parsedData)
        setTotalDuration(parsedData[0].Duration)
        setFirstCheckinTime(parsedData[0].CheckinTime)
        setCheckOutTime(parsedData[0].CheckoutTime)
        setCheckinStatus(0)
        setCheckOutStatus(true)

        // Auto-close the "Checked Out" card after 40 seconds so the
        // dashboard becomes visible again. Cleared if closed manually.
        if (autoCloseTimerRef.current) clearTimeout(autoCloseTimerRef.current);
        autoCloseTimerRef.current = setTimeout(() => {
          setShowClockModal(false);
          setCheckOutStatus(false);
          autoCloseTimerRef.current = null;
        }, 40000);


        localStorage.setItem('clockInStatus', JSON.stringify({
          totalDuration: parsedData[0].Duration,
          firstCheckinTime: parsedData[0].CheckinTime,
          checkOutTime: parsedData[0].CheckoutTime,
          checkinStatus: 0,
          checkOutStatus: true
        }));

      })
      .catch((error) => {
        console.error('Error fetching:', error);

      });
  };




  const today = new Date();
  const dayName = today.toLocaleDateString('en-US', { weekday: 'long' });
  const date = today.toLocaleDateString('en-US');




  const formatDOSDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };





  const handlePrint = () => {
    window.print();
  };



  const formatDOBDate = (dateString) => {
    if (!dateString) {
      return "";
    }


    const specificDate = new Date("01/01/1900");
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "";
    }


    if (date.getTime() === specificDate.getTime()) {
      return "";
    }

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };




  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, "");

    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (!match) return value;

    return [
      match[1] && `(${match[1]}`,
      match[2] && `) ${match[2]}`,
      match[3] && `-${match[3]}`
    ].join("");
  };



  const fetchSuggestion = () => {
    const inputJSON = {
      PracticeID: userPracticeID,
      SearchKey: searchText,
      SearchBy: selectedSearchFilter,
      isFromLogin: 0
    };

    const sJSONInput = JSON.stringify(inputJSON);

    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${encodeURIComponent(sJSONInput)}`;

    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log("response.status", response.status);
        } else return response.json();
      })
      .then(data => {
        const parsedData = JSON.parse(data);
        const suggData = parsedData.Data;
       
        if (Array.isArray(suggData)) {

          const mappedSuggestions = suggData.map((item) => {
            let label = "";

            if (selectedSearchFilter === "0") {

              label = `${item.LastName ?? ""}, ${item.FirstName ?? ""}`.trim();
            } else if (selectedSearchFilter === "1") {

              const rawPhone = (item.CellPhoneNummber ?? "").replace(/\D/g, "");
              label = formatPhoneNumber(rawPhone);
            } else if (selectedSearchFilter === "2") {

              label = item.MRN ?? "";
            }
            else if (selectedSearchFilter === "3") {
              label = `${item.LastName ?? ""}, ${item.FirstName ?? ""}, -${formatDOBDate(item.DOB)}`.trim();
            }

            return {
              label,
              val: item.PatientID,
              fullData: item
            };
          });

          setSuggestions(mappedSuggestions);

        } else {
          setSuggestions([]);
          setSearchText('');
        }
      })
  }





  const handleInputKeyPress = (event) => {
    if (event.key === 'Backspace') {

      if (searchText === '' && suggestions.length > 0) {
        setSuggestions([]);


      } else {

        const updatedSearchText = searchText.slice(0, -1);
        setSearchText(updatedSearchText);


        fetchSuggestions(updatedSearchText);
      }
    } else if (event.key !== 'Enter') {

      setSearchText(event.target.value);
      fetchSuggestions(event.target.value);
    }
  };



  const fetchSuggestions = (text) => {
    if (!text) {
      setSuggestions([]);
      return;
    }

    fetchSuggestion();
  };



  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchText) {
        fetchSuggestion();
      }
    }, 400);

    return () => clearTimeout(delay);
  }, [searchText, selectedSearchFilter]);



  const handleSuggestionSelect = (item) => {

    setSearchText(item.label || item.val);
    setSuggestions([]);
    setSelectedItem(item.val)

    //navigate(`/patient-dashboard/${item.val}/primary-insurance`);
    //window.location.reload();
    // setTimeout(() => {
    //   navigate(`/patient-dashboard/${item.val}/primary-insurance`, { replace: true });
    // }, 0);

    window.open(`#/patientdashboard/${item.val}/primary-insurance`)

    setSearchText('')


  };








  // const handleLogout = async () => {

  //   setLoading(true)

  //   const inpuJson = {
  //     UserID: userId,
  //     PracticeID: userPracticeID,

  //   }


  //   const sJSONInput = JSON.stringify(inpuJson);



  //   const url = `${APIConstants.SERVICES_URL}${LoginConstants.Logout}?sInputJSON=${sJSONInput}`;

  //   fetch(url, {
  //     method: 'POST',
  //     headers: {
  //       'Accept': 'application/json',
  //       'Content-Type': 'application/json'
  //     }
  //   })

  //     .then((response) => {
  //       if (response.status != 200) { console.log("response.status", response.status); }
  //       else return response.json();
  //     })
  //     .then(data => {



  //       const parsedData = JSON.parse(data);
  //       localStorage.clear();
  //       sessionStorage.clear();
  //       setTimeout(() => {

  //         localStorage.removeItem('activePage');
  //         localStorage.removeItem('userToken');

  //         navigate("/")
  //       }, 500);


  //     })
  //     .catch((error) => {
  //       console.error('Error fetching:', error);
  //     });
  // };







  function getAppLoactionLabelClass(appLocationName) {
    if (appLocationName === 'TP1' || appLocationName === 'TL3') {
      return 'applocation';
    } else if (appLocationName === 'Sec') {
      return 'applocation2';
    } else if (appLocationName === 'NE') {
      return 'applocation3';
    } else {
      return '';
    }


  }




  useEffect(() => {
    const handleHashChange = () => {
      setActivePage(window.location.hash.replace("#/", "") || "BillingDashboard");
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  /**
   * In-app route change, not a new browser tab.
   *
   * This was `window.open('/#/' + pageName, '_blank')`, which made every click
   * on the menu boot the whole application again: the bundle is a single 4.5 MB
   * chunk with all 34 routes imported eagerly, so each tab re-downloaded it,
   * re-parsed it, re-mounted React and re-ran auth before it could draw
   * anything. Routing through the router reuses the app that is already
   * running, so the switch is immediate.
   */
  const handleMenuClick = (pageName) => {
    navigate(`/${pageName}`);
  };





  const menuOptions = [
    { value: "claim-approval", label: "Approval" },
   
    { value: "ClaimStatus", label: "Claim Status" },
   
    { value: "IntelliBill", label: "Intelli Bill" },
    { value: "Lab-Billing", label: "Lab Billing" },
    { value: "new-encounter", label: "New Encounter" },
    { value: "posting-payments", label: "Posting Payments" },
    { value: "SuperBill", label: "Super Bill" },
    { value: "Upload-RemittanceFiles", label: "Remittance Upload" },
    { value: "workableclaims", label: "Workable Claims" },
    { value: "UpdateCPT", label: "Edit CPT" },

  ];


  const sortedOptions = menuOptions.sort((a, b) => a.label.localeCompare(b.label));



  const [openDropdown, setOpenDropdown] = useState(null);

 
  const handleDropdownToggle = (menuName) => {
    setOpenDropdown(menuName);
  };




  // Check if the current route is the login page
  const isLoginPage = location.pathname === '/';

  if (isLoginPage) {
    return null; // Return null to hide the sidebar on the login page
  }




  const isLocPage = location.pathname === '/locations';

  if (isLocPage) {
    return null;
  }



  return (
    <>
      {/* Top bar. Everything used to be laid out with hardcoded marginLeft values
          (360px / 600px / 780px / 120px), which only lined up at one window width.
          The bar is now three flex groups - identity, patient context, actions -
          so the spacing holds at every width and the groups wrap instead of
          colliding. */}
      <div className='top-container'>

        <div className='hv-topbar__identity'>

          {DemoGraphyData && DemoGraphyData.MRN ? (
            <>
              <span className='pracnumber-style'>
                <span className='pracnumber-style__dot' />
                {userData.practiceFullID}
              </span>
              <span className={`pracloc-style ${getAppLoactionLabelClass(DemoGraphyData.LocationNickName)}`}>
                {DemoGraphyData.LocationNickName}
              </span>
            </>
          ) : (
            <span className='pracnumber-style'>
              <span className='pracnumber-style__dot' />
              {userData.practiceFullID}
            </span>
          )}

          <span className='hv-topbar__rule' />

          <span className='username-style'>
            <span className='username-style__role'>{roleLabel}</span>
            <span className='username-style__name'>{userData.userFullName}</span>
          </span>

        </div>

        {DemoGraphyData && DemoGraphyData.MRN && (
          <div className='hv-topbar__patient'>

            <span className='hv-patient-chip'>{DemoGraphyData.MRN || ""}</span>
            <span className='hv-patient-chip'>{`${DemoGraphyData.LastName},${DemoGraphyData.FirstName}` || ""}</span>
            <span className='hv-patient-chip'>{formatDOBDate(DemoGraphyData.DOB)}</span>
            <span className='hv-patient-chip'>{DemoGraphyData.Age || ""} Years</span>
            <span className='hv-patient-chip'>{DemoGraphyData.Gender || ""}</span>

            <button
              type='button'
              className='hv-patient-action'
              onClick={handlePrint}
              aria-label='Print patient summary'
            >
              <FontAwesomeIcon icon={faPrint} />
            </button>

            <span className='hv-patient-action is-static'>
              <FontAwesomeIcon icon={faFlag} />
            </span>

          </div>
        )}

        <div className='hv-topbar__actions'>

          {checkinStatus == 0 ?

            <button className='clock-btn' onClick={() => fetchUserClockStatus(true)}>
              <FontAwesomeIcon icon={faClock} />
              Clock-in
            </button> :
            <button
              className='initial'
              onClick={() => fetchUserClockStatus(true)}
              title='You are clocked in - click to clock out'
            >
              <span className='initial__dot' />
              <FontAwesomeIcon icon={faStopwatch} />
              <span className='initial__label'>Clock-Out</span>
              <span className='initial__timer'>{duration}</span>
            </button>
          }

          <button className='lg-out' type='button' onClick={handleLogout} aria-label='Log out'>
            <FontAwesomeIcon icon={faRightFromBracket} />
          </button>

        </div>

      </div>


      <div className='nav-container'>


        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleSidebar}
          aria-label="Toggle navigation"
        >
          <FontAwesomeIcon icon={faBars} className="navbar-toggler-icon" />
        </button>

        {/* <Sidebar> moved to App so it can sit beside the routed page inside
            .hv-shell. The hamburger above still opens it via toggleSidebar. */}




        <ul className='nav-icons'>
          <li title="Billing Dashboard">
            <FontAwesomeIcon
              className={` ${activePage === 'Billingdasboard' ? 'active-icon' : ''}`}
              onClick={() => handleMenuClick('Billingdasboard')}
              icon={faGaugeHigh}
            />
          </li>
          {/* No <li> wrapper: DropdownMenu's own root element IS an <li>
              (it needs position:relative to anchor its flyout). Wrapping it
              produced <li><li>...</li></li>, which React flagged as invalid DOM
              nesting. `.nav-icons li` is a descendant selector, so the inner
              <li> still picks up the same layout it always had. */}
          <DropdownMenu
            activePage={activePage}
            icon={faFileInvoiceDollar}
            options={sortedOptions}
            handleMenuClick={handleMenuClick}
            openDropdown={openDropdown}
            handleDropdownToggle={handleDropdownToggle}
            menuName="invoice"
            title="Claims & Billing"
          />
          <DropdownMenu
            activePage={activePage}
            options={[{ value: "BillerPatientTracker", label: "Patient Tracker" }]}
            handleMenuClick={handleMenuClick}
            icon={faHospitalUser}
            openDropdown={openDropdown}
            handleDropdownToggle={handleDropdownToggle}
            menuName="patientTracker"
            title="Patient Tracker"
          />
          <DropdownMenu
            activePage={activePage}
            options={[
              { value: "RHMAgingRecievedCharges", label: "AR Aging Report" },
              { value: "InsurancePaymentReport", label: "Insurance Payment Report" },
              { value: "CptReport", label: "CPT Report" }

            ]}
            handleMenuClick={handleMenuClick}
            icon={faChartColumn}
            openDropdown={openDropdown}
            handleDropdownToggle={handleDropdownToggle}
            menuName="InsurancePaymentReport"
            title="Reports"
          />

          <DropdownMenu
            activePage={activePage}
            icon={faGear}
            options={[{ value: "MedicalClaimMacro", label: "Macro" }]}
            handleMenuClick={handleMenuClick}
            openDropdown={openDropdown}
            handleDropdownToggle={handleDropdownToggle}
            menuName="macro"
            title="Macros & Settings"
          />

        </ul>

        <span className='hv-navbar__rule' />


        {loading && (
          <div className="overlay">
            <div className="spinner-container">
              <div className="spinner-grow text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="spinner-grow text-warning" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="spinner-grow text-info" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        )}


        {DemoGraphyData && DemoGraphyData.MRN && (
          <div className='hv-navbar__date'>
            <span className='hv-navbar__day'>{dayName}</span>
            <span className='hv-navbar__datevalue'>{date}</span>
          </div>
        )}


        <div className='hv-navbar__search'>

          <label className='hv-navbar__searchlabel' htmlFor='hv-navbar-search-input'>Search by</label>

          <div className='hv-searchgroup'>

            <select
              className='hv-searchgroup__select'
              name="select"
              aria-label="Search by"
              value={selectedSearchFilter}
              onChange={(e) => setSelectedSearchFilter(e.target.value)}
            >
              <option value="0">Name</option>
              <option value="1">Phone</option>
              <option value="2">MRN</option>
              <option value="3">DOB</option>
            </select>

            <div className='hv-searchgroup__field'>
              <input
                id='hv-navbar-search-input'
                className='hv-searchgroup__input'
                type='text'
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={handleInputKeyPress}
                placeholder='Search patient...'
              />
              {suggestions.length > 0 && (
                <div className='autocomplete-style' style={{ zIndex: '10' }} >
                  <ul className='list-style'>
                    {suggestions.map((suggestion) => (
                      <li key={suggestion.val} value={suggestion.val} onClick={() => handleSuggestionSelect(suggestion)}>{suggestion.label}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            <button
              type='button'
              className='hv-searchgroup__btn'
              onClick={() => fetchSuggestion()}
              aria-label='Search patient'
            >
              <FontAwesomeIcon icon={faMagnifyingGlass} />
            </button>

          </div>

        </div>






        {showClockModal && (
          <div className="clockGlassOverlay">

            {checkOutStatus ? (
              <div className="clockGlassCard checkoutSummary">
                <button className="clockGlassClose" onClick={handleCloseModals} aria-label="Close">
                  <FontAwesomeIcon icon={faCircleXmark} />
                </button>

                <div className="clockGlassTime">{currentTime}</div>
                <div className="clockGlassDate">{defaultDate}</div>

                <span className="clockGlassPill isOut">
                  <span className="clockGlassDot" />
                  Checked Out
                </span>

                <div className="clockGlassBody">
                  <FontAwesomeIcon icon={faCircleXmark} className="clockGlassStatusIcon isOut" />
                  <div className="clockGlassMeta">
                    <div className="clockGlassCheckinTime">Clock-in: {firstCheckinTime}</div>
                    <div className="clockGlassCheckinTime">Clock-out: {CheckOutTime}</div>
                    <div className="clockGlassDuration">{totalDuration}</div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="clockGlassCard">
                <button className="clockGlassClose" onClick={handleCloseModals} aria-label="Close">
                  <FontAwesomeIcon icon={faCircleXmark} />
                </button>

                <div className="clockGlassTime">{currentTime}</div>
                <div className="clockGlassDate">{defaultDate}</div>

                <span className={`clockGlassPill ${checkinStatus == 0 ? 'isOut' : 'isIn'}`}>
                  <span className="clockGlassDot" />
                  {checkinStatus == 0 ? "Not Checked In" : "Checked In"}
                </span>

                <div className="clockGlassBody">
                  <FontAwesomeIcon
                    icon={checkinStatus == 0 ? faCircleXmark : faCircleCheck}
                    className={`clockGlassStatusIcon ${checkinStatus == 0 ? 'isOut' : 'isIn'}`}
                  />
                  <div className="clockGlassMeta">
                    {firstCheckinTime && <div className="clockGlassCheckinTime">{firstCheckinTime}</div>}
                    <div className="clockGlassDuration">{duration}</div>
                  </div>
                </div>

                {checkinStatus == 0 ?
                  <button className="clockRippleBtn clockIn" onClick={fetchUserClockIn}>
                    Clock In
                  </button> :
                  <button className="clockRippleBtn clockOut" onClick={fetchUserClockOut}>
                    Clock Out
                  </button>
                }
              </div>
            )}

          </div>
        )}

      </div>





    </>
  )
}

export default Navbar